import React from 'react'
import { Box, Typography, Container, List, ListItem, IconButton } from '@mui/material';

const Home = () => {
    return (
        <Box
            sx={{
                height: '100vh',
                width: '100%',
                backgroundColor: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
                overflow: 'hidden',
                color: '#000000',
                // Capa para el logo tenue
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    backgroundImage: 'url("/logo-watermark.png")',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: { xs: 'center right -20%', md: 'center left 50%' },
                    backgroundSize: { xs: '75%', md: '50%', lg: '60%' },
                    opacity: 0.07,
                    zIndex: 0,
                }
            }}
        >
            <Container
                maxWidth="xl"
                sx={{
                    zIndex: 1, // Esto pone el texto por ENCIMA del logo tenue
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    position: 'relative',
                    px: { xs: 4, md: 18 },
                    width: '100%' // Asegura que el contenedor ocupe todo el ancho disponible
                }}
            >
                {/* Texto Central */}
                <Box sx={{ 
                    pl: { xs: 8, md: 12, lg: 18 }, 
                    maxWidth: { xs: '100%', md: '700px', lg: '1000px' },
                    //transform: 'translateY(-50px)' // Ajusta este valor (ej. -50px, -10vh) para subirlo más o menos
                }}>
                    <Typography
                        variant="h1"
                        sx={{
                            fontFamily: "'ITC Blair', sans-serif",
                            fontWeight: 500,
                            fontSize: { xs: '2.2rem', sm: '3.0rem', md: '4rem' },
                            mb: 3,
                            letterSpacing: -1.5,
                            lineHeight: 1.1
                        }}
                    >
                        Alarmas Cerberus
                    </Typography>
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 220,
                            color: '#444444',
                            fontSize: { xs: '1.2rem', md: '1.6rem' },
                            maxWidth: '550px',
                            lineHeight: 1.5,
                            borderLeft: '2px solid #d87123',
                            paddingLeft: 3,
                            marginLeft: { xs: 0, md: 0.5 },
                        }}
                    >
                        <i>"Cada lugar donde nos sentimos seguros es un tesoro"</i>  Jan Jansen.
                    </Typography>
                </Box>


            </Container >


        </Box>
    )
}

export default Home